import React from "react";
import { AboutUs, Navbar } from "../components";

const About = () => {
  return (
    <div>
      <div className="gradient-bg-welcome">
        <Navbar />
        <AboutUs />
      </div>
    </div>
  );
};

export default About;
